
import React from 'react'
import {Nav, NavItem} from 'react-bootstrap';
import Navbar from 'react-bootstrap/Navbar';
import Offcanvas from 'react-bootstrap/Offcanvas';
import 'bootstrap/dist/css/bootstrap.min.css'
import "./layoutnavbar.css"
import { ArrowBack } from "@mui/icons-material"
import { useState } from "react";
import StatusContext from "../../contexts/StatusContext";
import AuthContext from "../../contexts/AuthContext";
import {Credits} from "../main/credits/Credits"

import { LinkButton } from '../main/linkbutton/LinkButton';
import { SignupDialog } from '../main/signupdialog/SignupDialog';

import LanguageIcon from '@mui/icons-material/Language';
import { DialogLanguages } from './DialogLanguages';

import MenuIcon from '@mui/icons-material/Menu';




export const NavBar = ()=> {
  const [expanded, setExpanded] = useState(false);
  
  
  const {
    isMe,
    isMobile,
    setShowMainLanguage,
    changeLanguage,
    setShowLoginDialog,
    setShowSignupDialog,
    enablesignupdialog,
    setEnableSignupDialog,
    setShowCreditsDialog,
    showcreditsdialog,
    setShowLanguages,
    shortLanguage,
   
} = React.useContext(StatusContext);

  const {
    checkCurrentUser,
  } = React.useContext(AuthContext);

 
  const handleLinkClick = (e) => {
    setExpanded(false); // Close the navbar
};


  const onShowGlobe = () => {
 
    setShowLanguages(true);
  }

  const handleCredits = () => {
   
    setShowCreditsDialog(true)
    setExpanded(false)
  }

  const handleLoginDlg = () => {
    setExpanded(false)
   
    setShowLoginDialog(true)
   
  }

  const handleLogout = () => {
    console.log("handleLogout")
    
    localStorage.setItem('Logout', 'Yes')
    setExpanded(false)
    //window.open('https://www.example.com', '_blank');
    window.open('/', '_blank');

  }

  const handleSignupDlg = () => {
    setExpanded(false)
    setEnableSignupDialog(true)
    setShowSignupDialog(true)
  }

  const handleonArrowClick = () => {
   
    setExpanded(!expanded)
  }

  const handleonClickNavBar = () => {
   
    setExpanded(!expanded)
    
    setShowMainLanguage(false);
  }  

 
  return (
   
    <Navbar expanded={expanded} key={false} bg="light" expand={false} className="mb-0 py-0 navbar-custom" sticky='top'>
      
      <div className = "layoutNavbar">
      
        <Navbar.Brand>
       
          <div className = {!isMobile() ? 'flex-container' : ''}>
            <label style={{fontWeight:"500"}}>DedaAI</label>
          </div>
         
        </Navbar.Brand >
        
        <div className='flex-container'>
        
          <MenuIcon style = {{ fontSize: '26px', color:'maroon', width:'40px'}}onClick = {()=> {handleonClickNavBar()}} />
          <div style={{marginLeft: '10px'}}>
          <LanguageIcon sx={{ fontSize: 20, color:'maroon', marginBottom: '2px'}} onClick = {()=> { onShowGlobe()}}/>
            <span style={{paddingLeft: '5px', paddingRight:'5px'}}>{shortLanguage}</span>
          </div>
        </div>
      
     
        <Navbar.Offcanvas
          id={`offcanvasNavbar-expand-false`}
          aria-labelledby={`offcanvasNavbarLabel-expand-false`}
          placement="end"
        >
           
        
          <Offcanvas.Header onClick = {handleonClickNavBar} >
            <Offcanvas.Title id={`offcanvasNavbarLabel-expand-false`}>
            <ArrowBack className="navbararrowBack" onClick = {handleonArrowClick} />
          
            </Offcanvas.Title>
          </Offcanvas.Header>
          <Offcanvas.Body>
            <Nav className="justify-content-end flex-grow-1 pe-3 navbarTemplateName">

            <div className="navbarSpace">
              <NavItem >
              
               <hr style={{marginTop: '-15px'}}></hr>
                
              {
                  <>
                  <Nav.Link href={`/home/${"start"}`} target="_blank " onClick={handleLinkClick}>{changeLanguage('mainmenu', 'home')}</Nav.Link>
                  {/*<Nav.Link href="/assistant" target="_blank" rel="noopener noreferrer" onClick={handleLinkClick}>{changeLanguage('mainmenu', 'writing')}</Nav.Link>*/}
                  <Nav.Link href={`/aitest/${"start"}`} target="_blank" rel="noopener noreferrer" onClick={handleLinkClick} >{changeLanguage('mainmenu', 'tests')}</Nav.Link>
                  
                  <Nav.Link href="/comprehensiveresponses" target="_blank" rel="noopener noreferrer" onClick={handleLinkClick}>{changeLanguage('mainmenu', 'comprehensiveresponses')}</Nav.Link>
                   <Nav.Link href="/copilot" target="_blank" rel="noopener noreferrer" onClick={handleLinkClick}>{changeLanguage('mainmenu', 'writing')}</Nav.Link>
                  
                  <Nav.Link href="/common"  target="_blank" rel="noopener noreferrer" onClick={handleLinkClick}>{changeLanguage('mainmenu', 'common')}</Nav.Link>
                  
                  <Nav.Link href="/templates" target="_blank" rel="noopener noreferrer" onClick={handleLinkClick}>{changeLanguage('mainmenu', 'templates')}</Nav.Link>
                  <Nav.Link href="/jobinterview" target="_blank" rel="noopener noreferrer" onClick={handleLinkClick}>{changeLanguage('mainmenu', 'jobinterview')}</Nav.Link>
                  <Nav.Link href="/compareai" target="_blank" rel="noopener noreferrer" onClick={handleLinkClick}>{changeLanguage('mainmenu', 'compareai')}</Nav.Link>
                  {
                     isMe() && 
                    <>
                      <Nav.Link href="/stocks" target="_blank" rel="noopener noreferrer" onClick={handleLinkClick}> STOCKS </Nav.Link>
                      <Nav.Link href="/documentanalysis" target="_blank" rel="noopener noreferrer" onClick={handleLinkClick}>{changeLanguage('mainmenu', 'documentanalysis')}</Nav.Link>
                      <Nav.Link href="/marketing" target="_blank" rel="noopener noreferrer" onClick={handleLinkClick}> Marketing </Nav.Link>
                    </>
                  }
                
                  {/*
                     isMe() && 
                      <Nav.Link href="/mytestpage" target="_blank" rel="noopener noreferrer" onClick={handleLinkClick}> Dashboard </Nav.Link>
                  */}
                  </>
              }
             
              </NavItem>
              <hr></hr>
              <NavItem>
              {!isMobile() ? 
                <> 
                
                  <LinkButton label = {changeLanguage('mainmenu', 'signup')} onClick={handleSignupDlg}/>
                 
                  {
                    (checkCurrentUser()) ?  
                  
                      <Nav.Link onClick={handleLogout} href={`home/${"logout"}`}>{changeLanguage('mainmenu', 'logout')}</Nav.Link>
                      :
                      <LinkButton label = {changeLanguage('mainmenu', 'login')} onClick={handleLoginDlg}/> 
                  }
                
                  <LinkButton label = {changeLanguage('mainmenu', 'credits')} onClick={handleCredits}/>  
                  {/*<Nav.Link href="/credits" target="_blank">{changeLanguage('mainmenu', 'credits')}</Nav.Link>*/}
                  <Nav.Link href="/contactus" target="_blank" rel="noopener noreferrer">{changeLanguage('mainmenu', 'contactus')}</Nav.Link>
                  <Nav.Link href="/aboutus" target="_blank" rel="noopener noreferrer">{changeLanguage('mainmenu', 'aboutus')}</Nav.Link>
                </>
                :
                <>
                 <LinkButton label = {changeLanguage('mainmenu', 'signup')} onClick={handleSignupDlg}/>
                   {
                    (checkCurrentUser()) ?  
                      <Nav.Link onClick={handleLogout} href={`/home/${"logout"}`} >{changeLanguage('mainmenu', 'logout')}</Nav.Link>
                      :
                      <LinkButton label = {changeLanguage('mainmenu', 'login')} onClick={handleLoginDlg}/> 
                  }
                  <LinkButton label = {changeLanguage('mainmenu', 'credits')} onClick={handleCredits}/>  
                
                  <Nav.Link href="/contactus"> {changeLanguage('mainmenu', 'contactus')}</Nav.Link>
                  <Nav.Link href="/aboutus">{changeLanguage('mainmenu', 'aboutus')}</Nav.Link>

                </>
              
              }
              
              {
                showcreditsdialog &&
                  <Credits />
              }
          
              {
                enablesignupdialog && 
                  <SignupDialog />
              }
              
              </NavItem>

              </div>
          
            </Nav>
          
          </Offcanvas.Body>
        </Navbar.Offcanvas>
        <DialogLanguages />
      </div>
    
    </Navbar>
   
  );
}

export default NavBar;